export const STORY_ROUTES = {
  CREATE: "/stories/create",
  VIEW: "/stories/view",
};

export const HASHTAG_ROUTES = {
  BASE: "/hashtags",
};
